export const QUERY_SEPARATOR = '|';
export const MAX_PRODUCTS = 4;
export const QUERY_PARAM_NAME = 'products';
export const COMPARE_CAROUSEL_CLASS = 'compare-carousel';
export var MinItems;
(function (MinItems) {
    MinItems[MinItems["MOBILE"] = 1] = "MOBILE";
    MinItems[MinItems["TABLET"] = 2] = "TABLET";
})(MinItems || (MinItems = {}));
export var Spacing;
(function (Spacing) {
    Spacing[Spacing["MOBILE"] = 16] = "MOBILE";
    Spacing[Spacing["TABLET"] = 24] = "TABLET";
})(Spacing || (Spacing = {}));
